const canadianProvinceCodeMap = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland",
  NT: "North West Territories",
  NS: "Nova Scotia",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon",
};

export const canadianProvicesAbbreviations = Object.entries(
  canadianProvinceCodeMap,
).map(([provinceAbbreviation]) => provinceAbbreviation);

export const canadianProvicesNames = Object.entries(
  canadianProvinceCodeMap,
).map(([_, provinceName]) => provinceName);
